import { takeLatest, put, select, all, call } from 'redux-saga/effects';
import { get } from '@api/sharing';
import { getDefaultStore } from 'jotai';
import { autoRequest } from '@api/createRequestStore';
import { DASHBOARD_TYPE } from '@utils/constants';
import { message } from 'antd';
import { TRIGGER_ADD_TAB } from '@store/dashboards/tabs/types';
import genApplyForAtomPersistence from '@store/common/initStore';
import { mlRouteKey } from '@utils/persistenceUtil';
import { addNewSharedTab } from '../../sharedTabs/action';
import * as actions from './actions';
import * as types from './types';
import selector, { sharingResponseSelector } from './selectors';
import * as baseActions from '../base/actions';
import * as autoRequestTypes from '@api/createRequestStore/types';

function* afterRequest() {
  const { state } = yield select(sharingResponseSelector);
  if (!state) {
    return;
  }
  const { mlStore, atomState } = state;
  const { payload } = yield select(selector);

  try {
    const { common } = state;
    const { selectedCustomerId } = common;

    yield put(baseActions.updateBase(mlStore));

    if (atomState) {
      const applyAtomPersistence = genApplyForAtomPersistence({
        configuration: { atomState },
        pageKey: mlRouteKey,
      });
      applyAtomPersistence(getDefaultStore());
    }
    yield all([
      put(
        addNewSharedTab(
          {
            id: payload,
            state: mlStore,
            type: DASHBOARD_TYPE.ML,
          },
          selectedCustomerId,
        ),
      ),
      put({
        type: TRIGGER_ADD_TAB,
        payload: {
          config: { base: mlStore },
          dashboardTypeId: DASHBOARD_TYPE.ML,
          unsaved: true,
          id: payload,
          name: `MetricLens ${payload}`,
          isSharing: true,
        },
      }),
    ]);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching(action) {
  try {
    yield put({ type: `${types.SCOPE}${autoRequestTypes.FETCHING}` });
    yield autoRequest(get, types.SCOPE, action.id, afterRequest);
  } catch (error) {
    yield call(message.error, error.message || 'Unknown error.');
    throw error;
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.GET_SHARING], fetching);
}

export default [watchInitRequest, watchFetching];
